import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import JqueryLoad from '../../../JqueryLoad/JqueryLoad';
import Hdashboard from "../../../components/Hdashboard";
import { AccessAccount, classroomDetails } from "../../../api/apiHandler";
import { CButton, CFormInput, CInputGroup } from "@coreui/react";
import FontAwesome from "react-fontawesome";
import DataTable from "react-data-table-component";
import Image from "../../../user.png";
import customStyles from "../../../utils/dataTableStyles";
import { TOAST_ERROR, displayPrice } from "../../../utils/common.service";
// OLD CODE (kept as it is) :
// import { encryptString } from "../../../api/apiClient";
import { encryptString, decryptString } from "../../../api/apiClient";
import { WEB_URL } from "../../../Config";
import CryptoJS from 'crypto-js';
import useDebounce from "../../../utils/useDebounce";

var key = CryptoJS.enc.Hex.parse('SuiCovwpMpoRQbNfTmDXHWVkQWdanYOm');
var iv = CryptoJS.enc.Hex.parse('SuiCovwpMpoRQbNf');

export default function Classroom({ isLoader }) {

  const [activeTab, setActiveTab] = useState(localStorage.getItem("Search_Tab") || 1);
  const [search, setSearch] = useState("");
  const debounceSearch = useDebounce(search, 750);
  const navigate = useNavigate();

  var [classData, set_class_data] = useState([]);
  var [clubData, set_club_class] = useState([]);
  var [quizData, set_quiz_class] = useState([]);
  var [compititionData, set_competitions_class] = useState([]);

  const handleTab = (tab) => {
    localStorage.setItem("Search_Tab", tab)
    setActiveTab(tab);
    setSearch("");
    setStatusType("");
    setClassType("");
    setCountry("");
    setStartDate("");
    setEndDate("");
  };

  // For Filter

  const [statusType, setStatusType] = useState("");
  const [classType, setClassType] = useState("");
  const [country, setCountry] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  // Function to handle status filter
  const handleStatusFilter = (type) => {
    setStatusType(type);
  };

  // Function to handle class type filter
  const handleClassTypeFilter = (type) => {
    setClassType(type);
  };

  // Function to handle country filter
  const handleCountryFilter = (country) => {
    setCountry(country);
  };

  const Start_Date = (date) => {
    setStartDate(date)
  }

  const End_Date = (date) => {
    setEndDate(date)
  }

  const resetFilters = () => {
    setStatusType("");
    setClassType("");
    setCountry("");
    setStartDate("");
    setEndDate("");

    if (fromDateRef.current) {
      fromDateRef.current.value = "";
    }
    if (toDateRef.current) {
      toDateRef.current.value = "";
    }

    const radioButtons = document.querySelectorAll("input[type='radio']");
    radioButtons.forEach((button) => {
      button.checked = false;
    });
  };

  useEffect(() => {
    if (activeTab == 1) {
      search_class_details();
    } else if (activeTab == 2) {
      search_clubs_details();
    } else if (activeTab == 3) {
      search_quiz_details();
    } else if (activeTab == 4) {
      search_competitions_details();
    }
    setActiveTab(localStorage.getItem("Search_Tab") || 1);

  }, [debounceSearch, statusType, classType, country, startDate, endDate, activeTab]);

  const search_class_details = () => {
    isLoader(true)
    classroomDetails({ activity_type: "class", search: search, is_status: statusType, class_type: classType, country, from_date: startDate, to_date: endDate }).then((response) => {
      if (response.code == 1) {
        const dataWithRowCount = response.data.map((row, index) => ({ ...row, count: index + 1 }));
        set_class_data(dataWithRowCount);
        isLoader(false)
      } else {
        set_class_data([]);
        isLoader(false)
      }
    })
  };

  const search_clubs_details = () => {
    isLoader(true)
    classroomDetails({ activity_type: "club", search: search, is_status: statusType, class_type: classType, country, from_date: startDate, to_date: endDate }).then((response) => {
      console.log('response :', response);
      if (response.code == 1) {
        const dataWithRowCount = response.data.map((row, index) => ({ ...row, count: index + 1 }));
        set_club_class(dataWithRowCount);
        isLoader(false)
      } else {
        set_club_class([]);
        isLoader(false)
      }
    })
  };

  const search_quiz_details = () => {
    isLoader(true)
    classroomDetails({ activity_type: "quiz", search: search, is_status: statusType, class_type: classType, country, from_date: startDate, to_date: endDate }).then((response) => {
      if (response.code == 1) {
        const dataWithRowCount = response.data.map((row, index) => ({ ...row, count: index + 1 }));
        set_quiz_class(dataWithRowCount);
        isLoader(false)
      } else {
        set_quiz_class([]);
        isLoader(false)
      }
    })
  };

  const search_competitions_details = () => {
    isLoader(true)
    classroomDetails({ activity_type: "competition", search: search, is_status: statusType, class_type: classType, country, from_date: startDate, to_date: endDate }).then((response) => {
      if (response.code == 1) {
        const dataWithRowCount = response.data.map((row, index) => ({ ...row, count: index + 1 }));
        set_competitions_class(dataWithRowCount);
        isLoader(false)
      } else {
        set_competitions_class([]);
        isLoader(false)
      }
    })
  };

  const handleRedirect = (id, class_id, category, activity_type, type) => {
    isLoader(true);
    AccessAccount({ user_id: id })
      .then((response) => {
        if (response.code === "1") {
          isLoader(false);

          localStorage.setItem("Ttoken", response.data[0]?.token);
          localStorage.setItem("TisLogin", true);
          localStorage.setItem("type", category);
          localStorage.setItem("Tid", id);
          localStorage.setItem("role", "admin");

          // Create the string to be encrypted
          let queryString = `${class_id}?type=${activity_type.activity_type}`;
          if (activity_type.activity_type === "class") {
            queryString += `&type_class=${type}`;
          }

          // Encrypt the full query string
          // const encryptedURL = encryptString(queryString);
          const encryptedURL = encodeURIComponent(btoa(CryptoJS.AES.encrypt(`${queryString}`, key, { iv: iv }).toString()));

          // Use the encrypted URL in the redirection
          let url;
          if (activity_type.activity_type === "class" || activity_type.activity_type === "club" || activity_type.activity_type === "competition") {
            if(category == "teacher"){
              url = `${WEB_URL}teach-detail/${encryptedURL}`;
            } else {
              url = `${WEB_URL}organization-tech-detail/${encryptedURL}`;
            }
          } else if (activity_type.activity_type === "quiz") {
            if(category == "teacher"){
              url = `${WEB_URL}view-details-quiz/${encryptedURL}`;
            } else {
              url = `${WEB_URL}organization-view-details-quiz/${encryptedURL}`;
            }
          }
          console.log('url: ', url);

          window.open(url, '_blank');

        } else {
          isLoader(false);
          TOAST_ERROR("ERROR..!!");
        }
      })
      .catch((error) => {
        TOAST_ERROR("ERROR..!!");
      });
  };

  /* ===== ADMIN LOGIN FLOW - START ===== */
  // Builds the same activity URL as handleRedirect() above (same encryption and the
  // same teacher / organization paths), but as a relative path so it can be used as
  // the page to land on once the login is done.
  const buildActivityPath = (class_id, category, activity_type, type) => {
    let queryString = `${class_id}?type=${activity_type.activity_type}`;
    if (activity_type.activity_type === "class") {
      queryString += `&type_class=${type}`;
    }
    const encryptedURL = encodeURIComponent(btoa(CryptoJS.AES.encrypt(`${queryString}`, key, { iv: iv }).toString()));

    if (activity_type.activity_type === "class" || activity_type.activity_type === "club" || activity_type.activity_type === "competition") {
      return category == "teacher" ? `teach-detail/${encryptedURL}` : `organization-tech-detail/${encryptedURL}`;
    } else if (activity_type.activity_type === "quiz") {
      return category == "teacher" ? `view-details-quiz/${encryptedURL}` : `organization-view-details-quiz/${encryptedURL}`;
    }
    return "";
  };

  // Opens the login screen with the teacher's / organization's email & password
  // pre-filled, the "Admin Login" flag and the activity URL to land on after login.
  const handleTeacherAdminLogin = (id, class_id, category, activity_type, type, row) => {
    try {
      // If the listing did not return the login details, the earlier flow is used.
      if (row?.email == undefined || row?.email == null || row?.email == '') {
        handleRedirect(id, class_id, category, activity_type, type);
        return;
      }

      const adminLoginPayload = {
        email: row?.email,
        password: decryptString(row?.password),
        is_admin_login: 1,          // Admin Login flag
        user_id: id,
        category: category,
        admin_id: localStorage.getItem("aID"),
        login_type: (row?.login_type != undefined && row?.login_type != null && row?.login_type != '') ? row?.login_type : "S",
        social_id: row?.social_id,
        // page to land on once the login is done
        redirect_url: buildActivityPath(class_id, category, activity_type, type),
      };

      const encryptedPayload = encryptString(JSON.stringify(adminLoginPayload));
      const url = `${WEB_URL}login?admin_login=${encryptedPayload}`;

      const adminLoginWindow = window.open(url, 'studentscholars_admin_login');
      if (adminLoginWindow) {
        adminLoginWindow.focus();
      }
    } catch (error) {
      console.log('handleTeacherAdminLogin error :', error);
      TOAST_ERROR("ERROR..!!");
    }
  };
  /* ===== ADMIN LOGIN FLOW - END ===== */

  // Columns for Classes
  const class_columns = [
    {
      name: 'No',
      selector: row => row.count,
      sortable: false,
      width: "50px"
    },
    {
      name: (
        <>
          Assigned Teacher's<br />Name
        </>
      ),
      selector: row => row.full_name,
      sortable: true,
      width: "160px"
    },
    {
      name: 'Category',
      selector: row => row.main_category,
      sortable: true,
      width: "120px"
    },
    {
      name: 'Name',
      // selector: row => row.title,
      selector: row => (
        // OLD CODE (kept as it is) : onClick={() => handleRedirect(row.teacher_id, row.id, row.category, { activity_type: "class" }, row.type)}
        <span onClick={() => handleTeacherAdminLogin(row.teacher_id, row.id, row.category, { activity_type: "class" }, row.type, row)} style={{ cursor: 'pointer' ,color :  "rgb(87, 8, 97)" }}>
            {row.title}
        </span>
      ),
      sortable: true,
      width: "250px"
    },
    {
      name: (
        <>
          View <br />Details
        </>
      ),
      width: "60px",
      cell: (row) => (
        <div className="d-flex justify-content-center">

          <div className="col me-2">
            <FontAwesome
              name="view"
              className="fs-5 fa-solid fa-eye  mx-2 my-2 bg-light text-secondary"
              onClick={() => navigate("/class_detail", { state: { class_id: row.id } })}
            ></FontAwesome>
          </div>

        </div>
      ),
    },
    {
      name: 'Status',
      cell: row => {
        switch (row.is_accepted) {
          case 0:
            return <button onClick={() => navigate("/class_detail", { state: { class_id: row.id } })} className="bg-warning border-0" style={{ width: "150px", cursor: "pointer" }}>Pending</button>;
          case 1:
            return <button onClick={() => navigate("/class_detail", { state: { class_id: row.id } })} className="bg-success border-0 text-light" style={{ width: "150px", cursor: "pointer" }}>Accepted</button>;
          case 2:
            return <button onClick={() => navigate("/class_detail", { state: { class_id: row.id } })} className="bg-danger border-0 text-light" style={{ width: "150px", cursor: "pointer" }}>Rejected</button>;
          case 3:
            return <button onClick={() => navigate("/class_detail", { state: { class_id: row.id } })} className="bg-info border-0 text-dark" style={{ width: "150px", cursor: "pointer" }}>Request for Resubmit</button>;
          case 4:
            return <button onClick={() => navigate("/class_detail", { state: { class_id: row.id } })} className="bg-warning border-0" style={{ width: "150px", cursor: "pointer" }}>Resubmitted</button>;
          default:
            return "";
        }
      },
      sortable: false,
      width: "180px"
    },
    // {
    //   name: 'URL',
    //   cell: (row) => (
    //     <button style={{ color: "rgb(87, 8, 97)", border: "none", background: "none" }}
    //       onClick={() => handleRedirect(row.teacher_id, row.id, row.category, { activity_type: "class" }, row.type)}
    //     >Click Here</button>
    //   ),
    //   sortable: false,
    //   width: "90px"
    // },
    {
      name: 'Price',
      selector: row => row.price,
      sortable: true,
      width: "110px",
      cell: row => `${displayPrice(row?.price, row?.currency_code, row?.currency_symbol)}`
    },
    {
      name: (
        <>
          Amount Generated<br />Till now
        </>
      ),
      selector: row => row.amount,
      sortable: true,
      width: "90px",
      cell: row => row.amount == null ? "$0" : `$${row.amount}`
    },
    {
      name: (
        <>
          Number of Learners<br />Currently Subscribed
        </>
      ),
      selector: row => row.total_learners,
      sortable: true,
      width: "100px"
    },
    {
      name: (
        <>
          Number of Learner's<br />Taken This Class
        </>
      ),
      selector: row => row.total_enrolled_learners,
      sortable: true,
      width: "100px"
    },
    {
      name: (
        <>
          Created<br />Date
        </>
      ),
      selector: row => {
        const date = new Date(row.created_at);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;
        const year = date.getFullYear();
        return `${formattedDay}-${formattedMonth}-${year}`;
      },
      sortable: true,
      width: "120px"
    },
    {
      name: (
        <>
          Deleted <br />Date
        </>
      ),
      selector: row => {
        if (!row.delete_date) {
          return "-";
        }
        const date = new Date(row.delete_date);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;
        const year = date.getFullYear();
        return `${formattedDay}-${formattedMonth}-${year}`;
      },
      sortable: true,
      width: "120px"
    },
  ]

  // Columns for Club
  const club_columns = [
    {
      name: 'No',
      selector: row => row.count,
      sortable: false,
      width: "60px"
    },
    {
      name: (
        <>
          Assigned Teacher's<br />Name
        </>
      ),
      selector: row => row.full_name,
      sortable: true,
      width: "160px"
    },
    {
      name: 'Category',
      selector: row => row.main_category,
      sortable: true,
      width: "120px"
    },
    {
      name: 'Name',
      // selector: row => row.title,
      selector: row => (
        // OLD CODE (kept as it is) : onClick={() => handleRedirect(row.teacher_id, row.id, row.category, { activity_type: "club" }, row.type)}
        <span onClick={() => handleTeacherAdminLogin(row.teacher_id, row.id, row.category, { activity_type: "club" }, row.type, row)} style={{ cursor: 'pointer' ,color :  "rgb(87, 8, 97)" }}>
            {row.title}
        </span>
      ),
      sortable: true,
      width: "250px"
    },
    {
      name: 'Status',
      cell: row => {
        switch (row.is_accepted) {
          case 0:
            return <button onClick={() => navigate("/club_details", { state: { club_id: row.id } })} className="bg-warning border-0" style={{ width: "150px", cursor: "pointer" }}>Pending</button>;
          case 1:
            return <button onClick={() => navigate("/club_details", { state: { club_id: row.id } })} className="bg-success border-0 text-light" style={{ width: "150px", cursor: "pointer" }}>Accepted</button>;
          case 2:
            return <button onClick={() => navigate("/club_details", { state: { club_id: row.id } })} className="bg-danger border-0 text-light" style={{ width: "150px", cursor: "pointer" }}>Rejected</button>;
          case 3:
            return <button onClick={() => navigate("/club_details", { state: { club_id: row.id } })} className="bg-info border-0 text-dark" style={{ width: "150px", cursor: "pointer" }}>Request for Resubmit</button>;
          case 4:
            return <button onClick={() => navigate("/club_details", { state: { club_id: row.id } })} className="bg-warning border-0" style={{ width: "150px", cursor: "pointer" }}>Resubmitted</button>;
          default:
            return "";
        }
      },
      sortable: false,
      width: "180px"
    },
    // {
    //   name: 'URL',
    //   cell: (row) => (
    //     <button style={{ color: "rgb(87, 8, 97)", border: "none", background: "none" }}
    //       onClick={() => handleRedirect(row.teacher_id, row.id, row.category, { activity_type: "club" }, row.type)}
    //     >Click Here</button>
    //   ),
    //   sortable: false,
    //   width: "90px"
    // },
    {
      name: (
        <>
          View<br />Details
        </>
      ),
      width: "50px",
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <div className="col me-2">
            <FontAwesome
              name="view"
              className="fs-5 fa-solid fa-eye  mx-2 my-2 bg-light text-secondary"
              onClick={() => navigate("/club_details", { state: { club_id: row.id } })}
            ></FontAwesome>
          </div>
        </div>
      ),
    },
    {
      name: 'Price',
      selector: row => row.price,
      sortable: true,
      width: "110px",
      cell: row => `${displayPrice(row?.price, row?.currency_code, row?.currency_symbol)}`
    },
    {
      name: (
        <>
          Amount Generated<br />Till now
        </>
      ),
      selector: row => row.amount,
      sortable: true,
      width: "100px",
      cell: row => row.amount == null ? "$0" : `$${row.amount}`
    },
    {
      name: (
        <>
          Number of Learners<br />Currently Subscribed
        </>
      ),
      selector: row => row.total_learners,
      sortable: true,
      width: "110px"
    },
    {
      name: (
        <>
          Number of Learner's<br />Taken This Class
        </>
      ),
      selector: row => row.total_enrolled_learners,
      sortable: true,
      width: "100px"
    },
    {
      name: (
        <>
          Created<br />Date
        </>
      ),
      selector: row => {
        const date = new Date(row.created_at);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;
        const year = date.getFullYear();
        return `${formattedDay}-${formattedMonth}-${year}`;
      },
      sortable: true,
      width: "120px"
    },
    {
      name: (
        <>
          Deleted <br />Date
        </>
      ),
      selector: row => {
        if (!row.delete_date) {
          return "-";
        }
        const date = new Date(row.delete_date);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;
        const year = date.getFullYear();
        return `${formattedDay}-${formattedMonth}-${year}`;
      },
      sortable: true,
      width: "120px"
    },

  ]

  // Columns for Quiz
  const quiz_columns = [
    {
      name: 'No',
      selector: row => row.count,
      sortable: false,
      width: "60px"
    },
    {
      name: (
        <>
          Assigned Teacher's<br />Name
        </>
      ),
      selector: row => row.full_name,
      sortable: true,
      width: "150px"
    },
    {
      name: 'Category',
      selector: row => row.main_category,
      sortable: true,
      width: "130px"
    },
    {
      name: 'Name',
      // selector: row => row.title,
      selector: row => (
        // OLD CODE (kept as it is) : onClick={() => handleRedirect(row.teacher_id, row.id, row.category, { activity_type: "quiz" }, row.type)}
        <span onClick={() => handleTeacherAdminLogin(row.teacher_id, row.id, row.category, { activity_type: "quiz" }, row.type, row)} style={{ cursor: 'pointer' ,color :  "rgb(87, 8, 97)" }}>
            {row.title}
        </span>
      ),
      sortable: true,
      width: "250px"
    },
    {
      name: 'Status',
      cell: row => {
        switch (row.is_accepted) {
          case 0:
            return <button onClick={() => navigate("/quiz_details", { state: { quiz_id: row.id } })} className="bg-warning border-0" style={{ width: "150px", cursor: "pointer" }}>Pending</button>;
          case 1:
            return <button onClick={() => navigate("/quiz_details", { state: { quiz_id: row.id } })} className="bg-success border-0 text-light" style={{ width: "150px", cursor: "pointer" }}>Accepted</button>;
          case 2:
            return <button onClick={() => navigate("/quiz_details", { state: { quiz_id: row.id } })} className="bg-danger border-0 text-light" style={{ width: "150px", cursor: "pointer" }}>Rejected</button>;
          case 3:
            return <button onClick={() => navigate("/quiz_details", { state: { quiz_id: row.id } })} className="bg-info border-0 text-dark" style={{ width: "150px", cursor: "pointer" }}>Request for Resubmit</button>;
          case 4:
            return <button onClick={() => navigate("/quiz_details", { state: { quiz_id: row.id } })} className="bg-warning border-0" style={{ width: "150px", cursor: "pointer" }}>Resubmitted</button>;
          default:
            return "";
        }
      },
      sortable: false,
      width: "180px"
    },
    // {
    //   name: 'URL',
    //   cell: (row) => (
    //     <button style={{ color: "rgb(87, 8, 97)", border: "none", background: "none" }}
    //       onClick={() => handleRedirect(row.teacher_id, row.id, row.category, { activity_type: "quiz" }, row.type)}
    //     >Click Here</button>
    //   ),
    //   sortable: false,
    //   width: "90px"
    // },
    {
      name: (
        <>
          View<br />Details
        </>
      ),
      width: "60px",
      cell: (row) => (
        <div className="d-flex justify-content-center">

          <div className="col me-2">
            <FontAwesome
              name="view"
              className="fs-5 fa-solid fa-eye  mx-2 my-2 bg-light text-secondary"
              onClick={() => navigate("/quiz_details", { state: { quiz_id: row.id } })}
            ></FontAwesome>
          </div>

        </div>
      ),
    },
    {
      name: 'Price',
      selector: row => row.price,
      sortable: true,
      width: "110px",
      cell: row => `${displayPrice(row?.price, row?.currency_code, row?.currency_symbol)}`
    },
    {
      name: (
        <>
          Amount Generated<br />Till now
        </>
      ),
      selector: row => row.amount,
      sortable: true,
      width: "100px",
      cell: row => row.amount == null ? "$0" : `$${row.amount}`
    },
    {
      name: (
        <>
          Number of Learners<br />Currently Subscribed
        </>
      ),
      selector: row => row.total_learners,
      sortable: true,
      width: "110px"
    },
    {
      name: (
        <>
          Number of Learner's<br />Taken This Class
        </>
      ),
      selector: row => row.total_enrolled_learners,
      sortable: true,
      width: "100px"
    },
    {
      name: (
        <>
          Created<br />Date
        </>
      ),
      selector: row => {
        const date = new Date(row.created_at);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;
        const year = date.getFullYear();
        return `${formattedDay}-${formattedMonth}-${year}`;
      },
      sortable: true,
      width: "120px"
    },
    {
      name: (
        <>
          Deleted <br />Date
        </>
      ),
      selector: row => {
        if (!row.delete_date) {
          return "-";
        }
        const date = new Date(row.delete_date);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;
        const year = date.getFullYear();
        return `${formattedDay}-${formattedMonth}-${year}`;
      },
      sortable: true,
      width: "120px"
    },

  ]

  // Columns for Competition
  const competition_columns = [
    {
      name: 'No',
      selector: row => row.count,
      sortable: false,
      width: "60px"
    },
    {
      name: (
        <>
          Assigned Teacher's<br />Name
        </>
      ),
      selector: row => row.full_name,
      sortable: true,
      width: "160px"
    },
    {
      name: 'Category',
      selector: row => row.main_category,
      sortable: true,
      width: "130px"
    },
    // {
    //   name: 'Name',
    //   selector: row => row.title,
    //   sortable: true,
    //   width: "220px"
    // },
    {
      name: 'Name',
      // selector: row => row.title,
      selector: row => (
        // OLD CODE (kept as it is) : onClick={() => handleRedirect(row.teacher_id, row.id, row.category, { activity_type: "competition" }, row.type)}
        <span onClick={() => handleTeacherAdminLogin(row.teacher_id, row.id, row.category, { activity_type: "competition" }, row.type, row)} style={{ cursor: 'pointer' ,color :  "rgb(87, 8, 97)" }}>
            {row.title}
        </span>
      ),
      sortable: true,
      width: "250px"
    },
    {
      name: 'Status',
      cell: row => {
        switch (row.is_accepted) {
          case 0:
            return <button onClick={() => navigate("/competition_details", { state: { competition_id: row.id } })} className="bg-warning border-0" style={{ width: "150px", cursor: "pointer" }}>Pending</button>;
          case 1:
            return <button onClick={() => navigate("/competition_details", { state: { competition_id: row.id } })} className="bg-success border-0 text-light" style={{ width: "150px", cursor: "pointer" }}>Accepted</button>;
          case 2:
            return <button onClick={() => navigate("/competition_details", { state: { competition_id: row.id } })} className="bg-danger border-0 text-light" style={{ width: "150px", cursor: "pointer" }}>Rejected</button>;
          case 3:
            return <button onClick={() => navigate("/competition_details", { state: { competition_id: row.id } })} className="bg-info border-0 text-dark" style={{ width: "150px", cursor: "pointer" }}>Request for Resubmit</button>;
          case 4:
            return <button onClick={() => navigate("/competition_details", { state: { competition_id: row.id } })} className="bg-warning border-0" style={{ width: "150px", cursor: "pointer" }}>Resubmitted</button>;
          default:
            return "";
        }
      },
      sortable: false,
      width: "180px"
    },
    // {
    //   name: 'URL',
    //   cell: (row) => (
    //     <button style={{ color: "rgb(87, 8, 97)", border: "none", background: "none" }}
    //       onClick={() => handleRedirect(row.teacher_id, row.id, row.category, { activity_type: "competition" }, row.type)}
    //     >Click Here</button>
    //   ),
    //   sortable: false,
    //   width: "90px"
    // },
    {
      name: (
        <>
          View <br />Details
        </>
      ),
      width: "60px",
      cell: (row) => (
        <div className="d-flex justify-content-center">

          <div className="col me-2">
            <FontAwesome
              name="view"
              className="fs-5 fa-solid fa-eye  mx-2 my-2 bg-light text-secondary"
              onClick={() => navigate("/competition_details", { state: { competition_id: row.id } })}
            ></FontAwesome>
          </div>
        </div>
      ),
    },
    {
      name: 'Price',
      selector: row => row.price,
      sortable: true,
      width: "110px",
      cell: row => `${displayPrice(row?.price, row?.currency_code, row?.currency_symbol)}`
    },
    {
      name: (
        <>
          Amount Generated<br />Till now
        </>
      ),
      selector: row => row.amount,
      sortable: true,
      width: "100px",
      cell: row => row.amount == null ? "$0" : `$${row.amount}`
    },
    {
      name: (
        <>
          Number of Learners<br />Currently Subscribed
        </>
      ),
      selector: row => row.total_learners,
      sortable: true,
      width: "110px"
    },
    {
      name: (
        <>
          Number of Learner's<br />Taken This Class
        </>
      ),
      selector: row => row.total_enrolled_learners,
      sortable: true,
      width: "100px"
    },
    {
      name: (
        <>
          Created<br />Date
        </>
      ),
      selector: row => {
        const date = new Date(row.created_at);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;
        const year = date.getFullYear();
        return `${formattedDay}-${formattedMonth}-${year}`;
      },
      sortable: true,
      width: "120px"
    },
    {
      name: (
        <>
          Deleted <br />Date
        </>
      ),
      selector: row => {
        if (!row.delete_date) {
          return "-";
        }
        const date = new Date(row.delete_date);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;
        const year = date.getFullYear();
        return `${formattedDay}-${formattedMonth}-${year}`;
      },
      sortable: true,
      width: "120px"
    },

  ]

  return (
    <>
      <JqueryLoad />
      <Hdashboard />
      <main>
        <div className="dashboard-app d-lg-flex">
          <header className="dashboard-toolbar d-lg-none d-flex justify-content-between">
            <div className="align-items-center justify-content-between d-flex">
              <div className="d-flex align-items-center">
                <a href="#!" className="menu-toggle align-items-center d-lg-none d-flex">
                  <i className="fa fa-bars" />
                </a>
                <a href="#" className="d-lg-none d-block brand-logo">
                  <img src="./assets/images/logo.png" alt="logo" />
                </a>
              </div>
            </div>
          </header>
          <div className="class-content">

            {/* Header Start */}
            <div className="nav justify-content-between" id="pills-tab" role="tablist">

              <ul className="nav custom_nav_bar nav-pills">
                <li className="nav-item" role="presentation" onClick={() => handleTab(1)}>
                  <button
                    className={`nav-link ${activeTab == 1 ? 'active' : ''} `}
                    // className="nav-link active"
                    id="pills-classes-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-classes"
                    type="button"
                    role="tab"
                    aria-controls="pills-classes"
                    aria-selected="true"
                  >
                    <span className="me-1">
                      <svg width={14} height={14} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12.5996 0.599609H1.39961C0.959609 0.599609 0.599609 0.959609 0.599609 1.39961V10.4663C0.599609 10.9063 0.959609 11.2663 1.39961 11.2663H4.59961V11.7996H4.06628C3.91961 11.7996 3.79961 11.9196 3.79961 12.0663V13.1329C3.79961 13.2796 3.91961 13.3996 4.06628 13.3996H9.93294C10.0796 13.3996 10.1996 13.2796 10.1996 13.1329V12.0663C10.1996 11.9196 10.0796 11.7996 9.93294 11.7996H9.39961V11.2663H12.5996C13.0396 11.2663 13.3996 10.9063 13.3996 10.4663V1.39961C13.3996 0.959609 13.0396 0.599609 12.5996 0.599609ZM11.2663 10.1996H10.1996C10.0529 10.1996 9.93294 10.0796 9.93294 9.93294C9.93294 9.78628 10.0529 9.66628 10.1996 9.66628H11.2663C11.4129 9.66628 11.5329 9.78628 11.5329 9.93294C11.5329 10.0796 11.4129 10.1996 11.2663 10.1996ZM12.8663 8.59961H1.13294V1.39961C1.13294 1.25294 1.25294 1.13294 1.39961 1.13294H12.5996C12.7463 1.13294 12.8663 1.25294 12.8663 1.39961V8.59961Z"
                          fill="#FFC924"
                        />
                        <path
                          d="M8.33307 4.59962H7.88774C7.81574 4.59962 7.74374 4.62895 7.69574 4.68228L6.99974 5.42095L6.30374 4.68228C6.2792 4.65597 6.24946 4.63503 6.21641 4.6208C6.18336 4.60657 6.14772 4.59936 6.11174 4.59962H5.66641C4.79974 4.59962 4.06641 5.27162 4.06641 6.06895V7.53295C4.06641 7.67962 4.18641 7.79962 4.33307 7.79962H9.66641C9.81307 7.79962 9.93307 7.67962 9.93307 7.53295V6.06895C9.93307 5.27162 9.19974 4.59962 8.33307 4.59962Z"
                          fill="#FFC924"
                        />
                        <path
                          d="M6.99935 4.53874C7.73573 4.53874 8.33268 3.94178 8.33268 3.2054C8.33268 2.46902 7.73573 1.87207 6.99935 1.87207C6.26297 1.87207 5.66602 2.46902 5.66602 3.2054C5.66602 3.94178 6.26297 4.53874 6.99935 4.53874Z"
                          fill="#FFC924"
                        />
                      </svg>
                    </span>
                    Classes
                  </button>
                </li>
                <li className="nav-item" role="presentation" onClick={() => handleTab(2)}>
                  <button
                    // className="nav-link" 
                    className={`nav-link ${activeTab == 2 ? 'active' : ''} `}
                    id="pills-clubs-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-clubs"
                    type="button"
                    role="tab"
                    aria-controls="pills-clubs"
                    aria-selected="false"
                  >
                    <span className="me-1">
                      <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M1.40625 2.8125C2.1829 2.8125 2.8125 2.1829 2.8125 1.40625C2.8125 0.6296 2.1829 0 1.40625 0C0.6296 0 0 0.6296 0 1.40625C0 2.1829 0.6296 2.8125 1.40625 2.8125Z"
                          fill="#FFC924"
                        />
                        <path
                          d="M14.5938 2.8125C15.3704 2.8125 16 2.1829 16 1.40625C16 0.6296 15.3704 0 14.5938 0C13.8171 0 13.1875 0.6296 13.1875 1.40625C13.1875 2.1829 13.8171 2.8125 14.5938 2.8125Z"
                          fill="#FFC924"
                        />
                        <path
                          d="M1.40625 16C2.1829 16 2.8125 15.3704 2.8125 14.5938C2.8125 13.8171 2.1829 13.1875 1.40625 13.1875C0.6296 13.1875 0 13.8171 0 14.5938C0 15.3704 0.6296 16 1.40625 16Z"
                          fill="#FFC924"
                        />
                        <path
                          d="M14.5938 16C15.3704 16 16 15.3704 16 14.5938C16 13.8171 15.3704 13.1875 14.5938 13.1875C13.8171 13.1875 13.1875 13.8171 13.1875 14.5938C13.1875 15.3704 13.8171 16 14.5938 16Z"
                          fill="#FFC924"
                        />
                        <path
                          d="M8.46875 7.30957V9.15845H9.875V6.84082H8.9375C8.67903 6.84082 8.46875 7.05107 8.46875 7.30957ZM7.0625 6.84082H6.125V9.15845H7.53125V7.30957C7.53125 7.05107 7.32097 6.84082 7.0625 6.84082Z"
                          fill="#FFC924"
                        />
                        <path
                          d="M13.2187 7.99991C13.2187 5.12234 10.8776 2.78125 7.99997 2.78125C5.12234 2.78125 2.78125 5.12234 2.78125 7.99991C2.78125 10.8775 5.12237 13.2186 7.99997 13.2186C10.8776 13.2186 13.2187 10.8775 13.2187 7.99991ZM10.8125 9.62747C10.8125 9.88634 10.6026 10.0962 10.3437 10.0962H5.65622C5.39734 10.0962 5.18747 9.88634 5.18747 9.62747V6.37234C5.18747 6.11347 5.39734 5.90359 5.65622 5.90359H7.06247C7.42237 5.90359 7.75097 6.03966 7.99997 6.26281C8.24897 6.03962 8.57756 5.90359 8.93747 5.90359H10.3437C10.6026 5.90359 10.8125 6.11347 10.8125 6.37234V9.62747Z"
                          fill="#FFC924"
                        />
                        <path
                          d="M1.40645 3.7502C1.25827 3.7502 1.11345 3.73577 0.972828 3.70933C0.971984 3.73795 0.970734 3.76652 0.970734 3.7953C0.970734 4.5498 1.26455 5.25908 1.79805 5.79255L2.13495 6.12945C2.73995 4.23698 4.23711 2.73989 6.12958 2.13492L5.79261 1.79802C5.25911 1.26452 4.5498 0.970703 3.79533 0.970703C3.76655 0.970703 3.73798 0.971953 3.70933 0.972797C3.73638 1.11577 3.75006 1.26095 3.7502 1.40645C3.7502 2.6988 2.6988 3.7502 1.40645 3.7502ZM13.8655 6.12948L14.2024 5.79258C14.7359 5.25911 15.0297 4.5498 15.0297 3.79533C15.0297 3.76655 15.0285 3.73798 15.0276 3.70936C14.8847 3.73641 14.7395 3.7501 14.594 3.75023C13.3016 3.75023 12.2502 2.69883 12.2502 1.40648C12.2502 1.2583 12.2647 1.11348 12.2911 0.972859C12.2625 0.972016 12.2339 0.970766 12.2051 0.970766C11.4506 0.970766 10.7413 1.26455 10.2078 1.79808L9.87089 2.13498C11.7633 2.73992 13.2605 4.23702 13.8655 6.12948ZM2.13492 9.87095L1.79802 10.2078C1.26452 10.7413 0.970703 11.4506 0.970703 12.2051C0.970703 12.2339 0.971953 12.2624 0.972797 12.291C1.11577 12.264 1.26095 12.2503 1.40645 12.2502C2.6988 12.2502 3.7502 13.3016 3.7502 14.594C3.7502 14.7421 3.73577 14.887 3.70933 15.0276C3.73795 15.0284 3.76655 15.0297 3.79533 15.0297C4.5498 15.0297 5.25911 14.7359 5.79261 14.2024L6.12952 13.8655C4.23705 13.2605 2.73992 11.7634 2.13492 9.87095ZM14.594 12.2502C14.7421 12.2502 14.887 12.2646 15.0276 12.2911C15.0284 12.2625 15.0297 12.2339 15.0297 12.2051C15.0297 11.4506 14.7359 10.7413 14.2024 10.2079L13.8655 9.87098C13.2605 11.7634 11.7633 13.2605 9.87086 13.8655L10.2078 14.2024C10.7413 14.7359 11.4506 15.0297 12.205 15.0297C12.2338 15.0297 12.2624 15.0285 12.291 15.0276C12.264 14.8847 12.2503 14.7395 12.2502 14.594C12.2502 13.3016 13.3016 12.2502 14.594 12.2502Z"
                          fill="#FFC924"
                        />
                      </svg>
                    </span>
                    Clubs
                  </button>
                </li>
                <li className="nav-item" role="presentation" onClick={() => handleTab(3)}>
                  <button
                    // className="nav-link"
                    className={`nav-link ${activeTab == 3 ? 'active' : ''} `}
                    id="pills-quizzes-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-quizzes"
                    type="button"
                    role="tab"
                    aria-controls="pills-quizzes"
                    aria-selected="false"
                  >
                    <span className="me-1">
                      <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M0.493344 2.06266L1.15609 1.39991L2.53606 2.77984L1.87331 3.44259L0.493344 2.06266ZM0 4.6875H1.90809V5.625H0V4.6875ZM0.503719 8.23812L1.88228 6.85953L2.54503 7.52228L1.16647 8.90084L0.503719 8.23812ZM13.4618 2.78125L14.8417 1.40125L15.5045 2.06403L14.1245 3.44397L13.4618 2.78125ZM14.0919 4.6875H16V5.625H14.0919V4.6875ZM13.4516 7.52366L14.1143 6.86091L15.4929 8.23947L14.8302 8.90222L13.4516 7.52366ZM8 16C9.29228 16 10.3438 14.9485 10.3438 13.6562V12.1875H5.65625V13.6562C5.65625 14.9485 6.70772 16 8 16ZM13.0775 4.24575C12.6518 1.78575 10.5163 0 8 0C5.48369 0 3.34822 1.78575 2.9225 4.24622C2.62769 5.95094 3.19122 7.679 4.42991 8.86781C5.09344 9.50484 5.49672 10.3558 5.60756 11.25H10.3925C10.5035 10.3554 10.9067 9.50472 11.5701 8.86781C12.8088 7.679 13.3723 5.95094 13.0775 4.24575ZM8.46875 8.4375H7.53125V7.5H8.46875V8.4375ZM8.83319 5.35166C8.60497 5.51969 8.46875 5.78881 8.46875 6.07163V6.5625H7.53125V6.07163C7.53125 5.49203 7.81016 4.94069 8.27734 4.59672C8.399 4.50716 8.46875 4.36941 8.46875 4.21875C8.46875 3.96028 8.25847 3.75 8 3.75C7.74153 3.75 7.53125 3.96028 7.53125 4.21875V4.6875H6.59375V4.21875C6.59375 3.44334 7.22459 2.8125 8 2.8125C8.77541 2.8125 9.40625 3.44334 9.40625 4.21875C9.40625 4.66394 9.19203 5.08747 8.83319 5.35166Z"
                          fill="#FFC924"
                        />
                      </svg>
                    </span>
                    Quizzes
                  </button>
                </li>
                <li className="nav-item" role="presentation" onClick={() => handleTab(4)}>
                  <button
                    className={`nav-link ${activeTab == 4 ? 'active' : ''} `}
                    // className="nav-link"
                    id="pills-competitions-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-competitions"
                    type="button"
                    role="tab"
                    aria-controls="pills-competitions"
                    aria-selected="false"
                  >
                    <span className="me-1">
                      <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M2.8253 6.42013L2.12871 5.98198C1.87557 5.82262 1.65897 5.61155 1.49311 5.36261C1.32725 5.11368 1.21588 4.8325 1.1663 4.53751C0.977742 3.41229 1.7169 2.34257 2.82455 2.1117V0.965414C2.79321 0.965414 2.76152 0.967352 2.72959 0.972727L2.71927 0.974477C0.947867 1.27129 -0.251758 2.95401 0.0451171 4.72541C0.12124 5.17858 0.292301 5.61052 0.547082 5.99293C0.801863 6.37534 1.13461 6.69957 1.52349 6.94435L3.06168 7.91179C2.91327 7.43991 2.83109 6.93904 2.8253 6.42013ZM13.2811 0.974508L13.2704 0.972695C13.239 0.967639 13.2072 0.965203 13.1754 0.965414V2.1117C14.2829 2.34229 15.0222 3.41216 14.8337 4.53751C14.7841 4.83251 14.6727 5.1137 14.5069 5.36265C14.341 5.6116 14.1244 5.82267 13.8713 5.98204L13.1747 6.42016C13.169 6.93907 13.0867 7.43995 12.9383 7.91182L14.4765 6.94438C15.2626 6.45004 15.8014 5.64126 15.9549 4.72545C16.2517 2.95401 15.0521 1.27135 13.2811 0.974508ZM3.58246 0.258789V6.36213C3.58246 8.79795 5.56412 10.7796 7.99996 10.7796C10.4358 10.7796 12.4175 8.79798 12.4175 6.36213V0.258789H3.58246ZM10.4142 5.00895L9.65668 5.74735C9.60931 5.79352 9.57388 5.85052 9.55344 5.91343C9.53301 5.97634 9.52818 6.04328 9.53937 6.10848L9.71821 7.1511C9.77537 7.48438 9.42556 7.73857 9.12624 7.5812L8.18987 7.08891C8.07102 7.02641 7.92902 7.02641 7.81015 7.08891L6.87377 7.5812C6.57446 7.73854 6.22462 7.48438 6.2818 7.1511L6.46065 6.10848C6.47182 6.04328 6.46699 5.97635 6.44655 5.91344C6.42611 5.85053 6.39069 5.79353 6.34334 5.74735L5.5858 5.00895C5.34365 4.77288 5.47727 4.36163 5.81193 4.31304L6.8588 4.16091C6.92427 4.1514 6.98644 4.12611 7.03995 4.08722C7.09347 4.04834 7.13672 3.99702 7.16599 3.9377L7.63415 2.98904C7.7838 2.68579 8.21624 2.68579 8.3659 2.98904L8.83405 3.9377C8.86333 3.99702 8.90659 4.04833 8.9601 4.08722C9.01361 4.1261 9.07578 4.15139 9.14124 4.16091L10.1881 4.31304C10.5227 4.3617 10.6564 4.77295 10.4142 5.00895ZM9.60515 13.1398C9.52642 13.1316 9.44733 13.1275 9.36818 13.1274H8.84721V11.5376H7.15274V13.1274H6.63177C6.55174 13.1274 6.47268 13.1317 6.3948 13.1398C5.2503 13.2583 4.35777 14.2256 4.35777 15.4014V15.7413H11.6421V15.4014C11.6421 14.2256 10.7496 13.2583 9.60515 13.1398Z"
                          fill="#FFC924"
                        />
                      </svg>
                    </span>
                    Competitions
                  </button>
                </li>
              </ul>

              <div className="d-flex align-items-center ms-5 mt-2">

                <div className="mb-2">
                  <div className="dropdown">
                    <button className="btn border-purple rounded-cricle rounded-pill dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      {activeTab == 1 ? "Class" : activeTab == 2 ? "Club" : activeTab == 3 ? "Quiz" : "Competition"} Status
                    </button>
                    <div className="dropdown-menu class_size_start filter_box">
                      <h3 className="fs-5 mb-3">{activeTab == 1 ? "Class" : activeTab == 2 ? "Club" : activeTab == 3 ? "Quiz" : "Competition"} Status</h3>
                      <form className="" action="" id="">
                        <div className="form-check">
                          <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                            onClick={() => handleStatusFilter("unlisted")} checked={statusType == "unlisted" ? true : false} />
                          <label className="form-check-label" htmlFor="flexRadioDefault1">
                            Rejected
                          </label>
                        </div>
                        <div className="form-check">
                          <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"
                            onClick={() => handleStatusFilter("listed")} checked={statusType == "listed" ? true : false} />
                          <label className="form-check-label" htmlFor="flexRadioDefault2">
                            Accepted
                          </label>
                        </div>
                        <div className="form-check">
                          <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault3"
                            onClick={() => handleStatusFilter("pending")} checked={statusType == "pending" ? true : false} />
                          <label className="form-check-label" htmlFor="flexRadioDefault3">
                            Pending
                          </label>
                        </div>
                        <div className="form-check">
                          <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault4"
                            onClick={() => handleStatusFilter("resubmit")} checked={statusType == "resubmit" ? true : false} />
                          <label className="form-check-label" htmlFor="flexRadioDefault4">
                            Re-Submit
                          </label>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                {activeTab == 1 ?
                  <div className="ms-2 mb-2">
                    <div className="dropdown">
                      <button className="btn border-purple rounded-cricle rounded-pill dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        Class Type
                      </button>
                      <div className="dropdown-menu class_size_start filter_box">
                        <h3 className="fs-5 mb-3">Class Type</h3>
                        <form className="" action="" id="">
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                              onClick={() => handleClassTypeFilter("Online")} checked={classType == "Online" ? true : false} />
                            <label className="form-check-label" htmlFor="flexRadioDefault1">
                              Online
                            </label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"
                              onClick={() => handleClassTypeFilter("In-Person")} checked={classType == "In-Person" ? true : false} />
                            <label className="form-check-label" htmlFor="flexRadioDefault2">
                              In-Person
                            </label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault3"
                              onClick={() => handleClassTypeFilter("Offline Course")} checked={classType == "Offline Course" ? true : false} />
                            <label className="form-check-label" htmlFor="flexRadioDefault3">
                              Offline Course
                            </label>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  : ""
                }

                <div className="ms-2 mb-2">
                  <div className="dropdown">
                    <button className="btn border-purple rounded-cricle rounded-pill dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      Country
                    </button>
                    <div className="dropdown-menu price_per_class filter_box">
                      <h3 className="fs-5 mb-3">Country</h3>
                      <form className="" action="" id="">
                        <div className="form-check">
                          <input className="form-check-input" type="radio" name="flexRadioDefault" id="any" onClick={() => handleCountryFilter("Australia")} checked={country == "Australia" ? true : false} />
                          <label className="form-check-label" htmlFor="any">
                            Australia
                          </label>
                        </div>
                        <div className="form-check">
                          <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" onClick={() => handleCountryFilter("Canada")} checked={country == "Canada" ? true : false} />
                          <label className="form-check-label" htmlFor="flexRadioDefault2">
                            Canada
                          </label>
                        </div>
                        <div className="form-check">
                          <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" onClick={() => handleCountryFilter("Singapore")} checked={country == "Singapore" ? true : false} />
                          <label className="form-check-label" htmlFor="flexRadioDefault2">
                            Singapore
                          </label>
                        </div>
                        <div className="form-check">
                          <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" onClick={() => handleCountryFilter("New Zealand")} checked={country == "New Zealand" ? true : false} />
                          <label className="form-check-label" htmlFor="flexRadioDefault2">
                            New Zealand
                          </label>
                        </div>
                        <div className="form-check">
                          <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" onClick={() => handleCountryFilter("United Kingdom")} checked={country == "United Kingdom" ? true : false} />
                          <label className="form-check-label" htmlFor="flexRadioDefault2">
                            UK
                          </label>
                        </div>
                        <div className="form-check">
                          <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" onClick={() => handleCountryFilter("United States")} checked={country == "United States" ? true : false} />
                          <label className="form-check-label" htmlFor="flexRadioDefault2">
                            USA
                          </label>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="mb-2 ms-3">
                  <div className="dropdown">
                    <button
                      className="btn border-purple rounded-cricle rounded-pill dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Select Date
                    </button>
                    <div className="dropdown-menu class_size_start filter_box">
                      <form className="" action="" id="">
                        <div className="form-group mb-4">
                          <label className="mb-2">From Date</label>
                          <input
                            type="date"
                            className="form-control"
                            onChange={(e) => {
                              Start_Date(e.target.value);
                            }}
                            ref={fromDateRef}
                            value={startDate}
                            placeholder="Start"
                          />
                        </div>
                        <div className="form-group mb-4">
                          <label className="mb-2">To Date</label>
                          <input
                            type="date"
                            className="form-control"
                            min={startDate}
                            onChange={(e) => {
                              End_Date(e.target.value);
                            }}
                            ref={toDateRef}
                            value={endDate}
                            placeholder="Start"
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="ms-4 mb-2" onClick={resetFilters}><a href="#" className="text-purple fw-500">Reset Filters</a></div>

              </div>
            </div>

            <div className="d-flex mt-2">
              <CInputGroup className="">
                <CFormInput type="text" placeholder="Search" onChange={(e) => setSearch(e.target.value)} />
                <CButton style={{ backgroundColor: "rgb(87, 8, 97)", color: "light" }}>
                  <FontAwesome name="search" className="fa-solid fa-search" />
                </CButton>
              </CInputGroup>
            </div>
            {/* Header End */}

            {/* Start Tab */}
            <div className="tab-content" id="pills-tabContent">
              {/*----------------------------------Tab1-------------------------------------------------*/}
              <div className={`tab-pane fade ${activeTab == 1 ? 'active show' : ''} `} id="pills-classes" role="tabpanel" aria-labelledby="pills-classes-tab">
                <div className="px-1 mt-3">
                  {(
                    classData && classData.length > 0 ? (
                      <>
                        <DataTable columns={class_columns} data={classData} pagination customStyles={customStyles} />
                      </>
                    ) : (
                      <p className="mt-5 text-center text-purple fw-500 fs-3 mt-5">No data Found</p>
                    )
                  )}
                </div>
              </div>
              {/*----------------------------------Tab2-------------------------------------------------*/}
              <div className={`tab-pane fade ${activeTab == 2 ? 'active show' : ''} `} id="pills-clubs" role="tabpanel" aria-labelledby="pills-clubs-tab">
                <div className="px-1 mt-3">
                  {(
                    clubData && clubData.length > 0 ? (
                      <>
                        <DataTable columns={club_columns} data={clubData} pagination customStyles={customStyles} />
                      </>
                    ) : (
                      <p className="mt-5 text-center text-purple fw-500 fs-3 mt-5">No data Found</p>
                    )
                  )}
                </div>
              </div>
              {/*----------------------------------Tab3-------------------------------------------------*/}
              <div className={`tab-pane fade ${activeTab == 3 ? 'active show' : ''} `} id="pills-quizzes" role="tabpanel" aria-labelledby="pills-quizzes-tab">
                <div className="px-1 mt-3">
                  {(
                    quizData && quizData.length > 0 ? (
                      <>
                        <DataTable columns={quiz_columns} data={quizData} pagination customStyles={customStyles} />
                      </>
                    ) : (
                      <p className="mt-5 text-center text-purple fw-500 fs-3 mt-5">No data Found</p>
                    )
                  )}
                </div>
              </div>
              {/*----------------------------------Tab4-------------------------------------------------*/}
              <div className={`tab-pane fade ${activeTab == 4 ? 'active show' : ''} `} id="pills-competitions" role="tabpanel" aria-labelledby="pills-competitions-tab">
                <div className="px-1 mt-3">
                  {(
                    compititionData && compititionData.length > 0 ? (
                      <>
                        <DataTable columns={competition_columns} data={compititionData} pagination customStyles={customStyles} />
                      </>
                    ) : (
                      <p className="mt-5 text-center text-purple fw-500 fs-3 mt-5">No data Found</p>
                    )
                  )}
                </div>
              </div>
            </div>
            {/* end Tab */}
          </div>
        </div>
      </main>
    </>
  );
}
